import styles from 'css/src/components/common/ColorDots.module.scss';

import React from 'react';
import classNames from 'classnames';

import { pickMostInterestingColors } from 'js/src/libs/color-utils';

const DEFAULT_MAX = 3;

type Size = 'sm' | 'md';

type ColorDotsProps = {
    colors: string[];
    size?: Size;
    max?: number;
    /** Shrinks the dots to fit a narrow container instead of overflowing it. */
    fitWidth?: boolean;
    className?: string;
};

const SIZE_CLASSES: Record<Size, string> = {
    sm: styles['size-sm'],
    md: styles['size-md'],
};

const ColorDots: React.FC<ColorDotsProps> = ({
    colors,
    size = 'sm',
    max = DEFAULT_MAX,
    fitWidth = false,
    className,
}) => {
    const pickedColors = React.useMemo(() => pickMostInterestingColors(colors, max), [colors, max]);
    if (pickedColors.length === 0) return null;
    return (
        <span
            className={classNames(
                styles['color-dots'],
                SIZE_CLASSES[size],
                { [styles['fit-width']]: fitWidth },
                className,
            )}
            aria-hidden="true"
        >
            {pickedColors.map((color, index) => (
                <span
                    key={`${color}-${index}`}
                    className={styles['color-dot']}
                    style={{ backgroundColor: color }}
                />
            ))}
        </span>
    );
};

export default ColorDots;
